module.exports = __webpack_public_path__ + "static/media/activity.098ea0aa.svg";